/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import { getCurrentUserId, gotoLastRoute, saveUserCurrentStoreInfo } from '@/model/dataLayer/api/SaaS/user'
import store from '@/model/global/store'
import { initHillo, requireOfflineMode } from '@/model/global/GlobalSettings'
import { getBaseAndUrlForDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { createUserRelationShip, getAllStoreIdForUser } from '@/model/dataLayer/api/SaaS/subscriptionService'
import { forceGetSystemSetting } from '@/model/dataLayer/api/NewSettings'

export async function enterStore (deviceId) {
  const { url } = await getBaseAndUrlForDeviceId(deviceId)
  await initHillo(deviceId, url)
  setTimeout(async () => {
    const symbol = await forceGetSystemSetting({
      section: 'currencySymbols',
      sKey: 'useCurrencySymbols',
      sValue: '€',
      defaultValue: '€',
      sType: 'string',
      minimumVersion: '1.7.784',
      sOptions: '',
      tagList: 'basic'
    })
    const adminMode = await forceGetSystemSetting({
      section: 'Supermarket',
      sKey: 'useSupermarketMode',
      sValue: 'normal',
      defaultValue: 'normal',
      sType: 'options',
      minimumVersion: '1.7.825',
      sOptions: 'normal,supermarket',
      tagList: 'basic'
    })
    store.commit('adminMode', adminMode)
    store.commit('currencySymbols', symbol)
  }, 20)
  return url
}

export async function useStore (deviceId, jump = true) {
  const url = await enterStore(deviceId)
  try {
    if (!requireOfflineMode()) {
      await saveUserCurrentStoreInfo(deviceId, url)
    }
  } catch (e) {

  }
  if (jump) {
    await gotoLastRoute()
  }
}

export async function addStore (deviceId) {
  const currentSet = await getAllStoreIdForUser(getCurrentUserId())
  console.log(currentSet)
  if (currentSet.find(s => s.deviceId === deviceId.toString() && s.userId === getCurrentUserId())) {
    return
  }
  store.commit('refreshLicense')
  await createUserRelationShip(deviceId)
}
